import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { from, Observable, switchMap } from 'rxjs';

import { AppState } from '../../app.state';
import { StorageService } from '../services/storage.service';

const PUBLIC_PATTERNS: RegExp[] = [
  /\/api\/login$/,
  /\/api\/customers$/,
  /\/api\/password\/email$/,
  /\/api\/password\/reset$/,
  /\/api\/versions(\?|$)/,
];

const defaultHeaders = { Accept: 'application/json' };

export const authTokenInterceptor: HttpInterceptorFn = (req, next) => {
  const store = inject(Store);
  const storageService = inject(StorageService);

  if (PUBLIC_PATTERNS.some((pattern) => pattern.test(req.url))) {
    return next(withAcceptHeader(req));
  }

  const cachedToken = store.selectSnapshot(AppState.getToken);

  if (cachedToken) {
    return next(withAuthHeaders(req, cachedToken));
  }

  return resolveToken(storageService)
      .pipe(
          switchMap((token) => next(token
                                    ? withAuthHeaders(req, token)
                                    : withAcceptHeader(req))),
      );
};

function withAuthHeaders(req: Parameters<HttpInterceptorFn>[0], token: string) {
  return req.clone({
    setHeaders: {
      ...defaultHeaders,
      Authorization: `Bearer ${ token }`,
    },
  });
}

function withAcceptHeader(req: Parameters<HttpInterceptorFn>[0]) {
  return req.clone({ setHeaders: defaultHeaders });
}

function resolveToken(storageService: StorageService): Observable<string | null> {
  return from(storageService.getToken());
}
